import React, { useState, useEffect } from 'react';
import PartiesTable from './partiestable';
import constant from '../../constant';
// import Navbar from '../../components/common/navbar';

const PartiesContent = () => {
  const [parties, setParties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchParties = async () => {
      const token = localStorage.getItem('token');
      const userRole = localStorage.getItem('role');
      const adminSelectedUser = localStorage.getItem('adminSelectedUser');

      if (!token) {
        setError('No authentication token found');
        setLoading(false);
        return;
      }

      let apiUrl = `${constant.REACT_APP_API_URL}/party`;

      if (userRole === 'admin' && adminSelectedUser) {
        apiUrl = `${constant.REACT_APP_API_URL}/party?userId=${adminSelectedUser}`;
      }

      try {
        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const result = await response.json();

        if (response.ok) {
          setParties(result.data);
        } else {
          setError(result.message || 'Failed to fetch parties');
        }
      } catch (error) {
        setError('Error fetching parties');
      } finally {
        setLoading(false);
      }
    };

    fetchParties();
  }, []);

  const handleDelete = (id) => {
    setParties(parties.filter((party) => party._id !== id));
  };

  const handleEdit = (updatedParty) => {
    setParties(parties.map((party) =>
      party._id === updatedParty._id ? updatedParty : party
    ));
  };


  if (loading) {
    return (
      <div className="flex justify-center items-center h-full">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <>   <div className="px-6 pt-16 md:pt-0">

      {/* <Navbar title="Party" /> */}

      {/* bg-white rounded-lg shadow */}
      <div className="">
        <div className="">
          <PartiesTable
            parties={parties}
            onDelete={handleDelete}
            onEdit={handleEdit}
          />
        </div>
      </div>
    </div>
    </>
  );
};

export default PartiesContent;